export const REACT_APP_NAV_ROUTES = {
  dashboard: "/dashboard",
  dashboard2: "/dashboard-v2",
  upsellDashboard: "/upsell-dashboard",
  leads: {
    EventLeads: "/event-leads",
    upsellLeads: "/upsell-leads",
    chatLeads: "/external-leads",
    chatLeadsManage: "/external-leads/manage",
    generalLeads: "/general-leads",
    leadSource: "/lead-source",
  },
  orgSettings: {

  },
  chat: "/chats",
  messageSequence: "/message-sequence",
  payment: {
    dashboard: "/payment/dashboard",
    paymentDetails: "/payment/payment-details",
    paymentReminder: "/payments/payment-reminder",
  },

  reports: {
    revenueReport: "/revenue-report",
    marginReport: "/event-report",
    roomReport: "/room-report",
    ownerSummaryReport: "/owner-summary-report",
    leadsReport: "/leads-report",
    cancellationReport: "/cancellation-report",
    guestVisitReport: "/guest-visit-report",
    onGoingList: "/on-going-list",
    dailySummery: "/daily-summery",
    weeklySummery: "/weekly-summery",
    employeePerformanceReport: "/employee-performance-report",
    employeeLeadFollowupReport: "/reports/employee-profromance-report",
    venuePerformanceOverview: "/venue-performance-overview",
    venueCalendar: "/venue-calendar",
    todaysFollowups: "/todays-followups",
    deliveryLogDetails: "/invoice",
  },

  booking: "/bookings",


  userOnboard: "/user-onboard",


  customer: "/view-customers",
  customer_overview: "/customer-overview",
  inventory: "/inventory",
  food: {
    FoodItems: "/food-items",
    FoodCategories: "/food-categories",
    MasterFoodMenu: "/master-food-menu",
    ImportFoodMenu: "/import-food-menu",
    ImportFoodMenuCreate: "/import-food-menu/create",
    ImportFoodMenuReview: "/import-food-menu/review",
  },
  service: {
    ServiceCategories: "/service-categories",
    Packages: "/packages",
    Items: "/items",
  },
  review: {
    Review: "/review",
    ManageReview: "/manage-review",
    ReviewQuestionnaire: "/review-questionnaire",
    ManageReviewQuestionnaire: "/review-questionnaire/manage",
    ReviewQR: "/review-qr",
    PublicReview: "/public/review",
  },
  campaigns: {
    whatsapp: {

    },
    voice: {
        campaigns: "/campaigns/voice-campaigns"
    }
  },
  WhatsAppCampaigns: {
    Campaigns: "/market-campaign",
    NewCampaign: "/market-campaign/manage",
    ManageAudience: "/market-campaign-audience",
    MetaTemplate: "/meta-templates",
    QuickReplyTemplate: "/quick-reply-templates",
    MasterQuickReplyTemplate: "/master-quick-reply-templates",
  },
  EnrUsers: "/enr-users",
  CompanyOutlet: "/company-outlet",
  Zones: "/zone-list",
  CompanyInformation: "/company-information",
  ManageEnv: "/manage-env",
  Automation: "/automation",
  MasterStatus: "/enr-status",
  ExternalLeadMasterStatus: "/external-lead-master-status",
  MasterForms: "/master-forms",
  ENRCancelationReason: "/enr-cancelation-reason",
  ENRSUPPORT: "/enr-support",
  SubscriptionBilling: "/choose-subscription-billing",
  OrganizationSettings: {
    companyWallet: "/company-wallet",
    ManageEvents: "/events",
    ManageVenue: "/venue",
    Users: "/users",
    EmailTemplates: "/email-templates",
    DynamicForms: "/dynamic-forms",
    UserBranch: "/user-branch",
    DeletedLeads: "/deleted-leads",
    WhatsAppQR: "/whatsapp-qr",
    OrgConfiguration: "/org-env-config",
    StatusLifeCycle: "/org-status",
    CustomCancellationReason: "/custom-cancellation-reason",
    ExternalLeadLifecycle: "/org-settings/external-lead-lifecycle",
    RestrictedWords: "/restricted-words",
    roomTypes: "/room-types",
    PrintTemplates: "/print-templates",
    OutletTemplates: "/templates",
  },
  Security: {
    Security: "/list-security-groups",
    RoleGroups: "/security/role-groups",
  },
  GenAI: {
    GenAIPrompt: "/gen-ai-prompt",
    GenAIContext: "/gen-ai-context",
    GenAiKnowledgeBase: "/gen-ai-knowledge-base",
    ActionItemCategory: "/action-item-category",
    ActionItemDynamicForm: "/action-item-dynamic-form",
    Intents: "/intents",
    AgentTools: "/agent-tools",
    Catalogs: "/catalogs",
    Debug: "/debug",
  },
  MyProfile: "/my-profile",
  subscription: {
    pricing: "/subscription/pricing",
    plans: "/subscription/plans",
    error: "/subscription-error",
    choose: "/choose-subscription-billing",
    required: "/subscription/required",
    upgrade: "/subscription/upgrade-required",
    addons: ""
  },
  moduleSettings: "/module-settings/:module_name",
  addons: "/addons",
};

